import { z } from "zod";
/**
 * Global Orama search language (ADR-0036 decision 6). One setting drives the
 * tokenizer on both the server index and the browser keyword index, so indexing
 * and querying always stem with the same language. The value is a short code
 * (`de`, `en`); the API reads it from `SEARCH_LANGUAGE` (ADR-0007) and serves it
 * same-origin through `GET /api/auth/config`, which the browser reads at boot.
 */
export const SEARCH_LANGUAGES = ["de", "en"];
/** German is the household catalog's default text language. */
export const DEFAULT_SEARCH_LANGUAGE = "de";
/** Validation schema for the public `searchLanguage` discovery value. */
export const searchLanguageSchema = z.enum(SEARCH_LANGUAGES);
/** Whether `value` is one of the supported short language codes. */
export function isSearchLanguage(value) {
    return typeof value === "string" && SEARCH_LANGUAGES.includes(value);
}
/**
 * Resolve the tokenizer components for `language`. Loaded lazily so the browser
 * bundle only pulls the stemmer/stop-words for the configured language; the
 * API restart (or browser reload) after a `SEARCH_LANGUAGE` change picks up the
 * new value without a rebuild.
 *
 * @param language short code from `SEARCH_LANGUAGES`.
 * @returns stemmer + stop-words components for an Orama `create()` call.
 */
export async function searchTokenizerConfig(language) {
    if (language === "de") {
        const [{ stemmer }, { stopwords }] = await Promise.all([
            import("@orama/stemmers/german"),
            import("@orama/stopwords/german"),
        ]);
        return { language: "german", stemming: true, stemmer, stopWords: stopwords };
    }
    const [{ stemmer }, { stopwords }] = await Promise.all([
        import("@orama/stemmers/english"),
        import("@orama/stopwords/english"),
    ]);
    return { language: "english", stemming: true, stemmer, stopWords: stopwords };
}
//# sourceMappingURL=search-language.js.map